/* Axiom Supply — Universal Product Fitment Check (product page).
   Year -> Make -> Model. Tells the shopper whether THIS product fits their
   vehicle, by checking the selected vehicle's fitment-collection handle against
   the product's collections (injected by Liquid as data-collections).

   Data: window.AXIOM_FITMENT (assets/vehicle-fitment-data.js, loaded first).
   Self-gates: stays hidden unless the product belongs to >=1 fitment collection.
   Pre-fills + auto-verifies from the saved garage (localStorage axiom_garage).
   See docs/product-fitment.md. */
(function () {
  'use strict';

  var CHECK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var XMARK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function root() {
    return (((window.Shopify || {}).routes || {}).root || '/').replace(/\/$/, '');
  }

  if (!window.customElements || customElements.get('product-fitment')) return;

  customElements.define(
    'product-fitment',
    class extends HTMLElement {
      connectedCallback() {
        this.data = window.AXIOM_FITMENT || [];
        this.order = window.AXIOM_FITMENT_MAKE_ORDER || [];
        // product's collection handles (membership = fitment)
        this.colSet = {};
        (this.getAttribute('data-collections') || '').split(',').forEach(function (h) {
          h = h.trim();
          if (h) this.colSet[h] = true;
        }, this);

        // THIS product's own year range (from its title, fallback handle). Fitment
        // COLLECTIONS are generation-level (e.g. one "2010-2018" RAM collection), but
        // a product is usually a finer year slice (e.g. the 2014-2018 SKU) that shares
        // that collection with sibling SKUs — so collection membership ALONE would
        // wrongly confirm fit for the whole generation. We only confirm a year the
        // product actually covers. 0 = unbounded (no year parsed → no clamp).
        var yr = this.parseYears(this.getAttribute('data-title')) ||
                 this.parseYears(this.getAttribute('data-handle')) || {};
        this.ymin = yr.min || 0;
        this.ymax = yr.max || 0;

        // Gate: only show on products that belong to >=1 collection-based fitment collection.
        var self = this;
        var hasFit = this.data.some(function (e) { return !e.prod && self.colSet[e.handle]; });
        if (!this.data.length || !hasFit) return; // stay hidden

        this.year = this.q('year');
        this.make = this.q('make');
        this.model = this.q('model');
        this.result = this.q('result');
        if (!this.year || !this.make || !this.model) return;
        this.candidates = [];

        this.fill(this.year, this.years().map(function (y) { return { label: String(y), value: String(y) }; }), 'Year');
        this.year.addEventListener('change', this.onYear.bind(this));
        this.make.addEventListener('change', this.onMake.bind(this));
        this.model.addEventListener('change', this.onModel.bind(this));

        this.removeAttribute('hidden'); // reveal
        this.restoreGarage();
      }

      q(name) { return this.querySelector('[data-pf="' + name + '"]'); }

      // Pull 19xx/20xx years out of a string (title/handle). The 19|20 prefix
      // intentionally ignores model numbers like 1500 / 2500 / 3500 / F-150.
      parseYears(str) {
        var m = String(str || '').match(/\b(?:19|20)\d{2}\b/g);
        if (!m || !m.length) return null;
        var ys = m.map(Number);
        return { min: Math.min.apply(null, ys), max: Math.max.apply(null, ys) };
      }

      years() {
        var min = 9999, max = 0;
        this.data.forEach(function (e) { if (e.start < min) min = e.start; if (e.end > max) max = e.end; });
        var out = [];
        for (var y = max; y >= min; y--) out.push(y);
        return out;
      }

      fill(sel, items, placeholder) {
        sel.innerHTML = '';
        var ph = new Option(placeholder, '');
        ph.disabled = true; ph.selected = true;
        sel.add(ph);
        items.forEach(function (it) { sel.add(new Option(it.label, it.value)); });
      }

      onYear() {
        this.hideResult();
        this.make.disabled = true; this.model.disabled = true;
        this.fill(this.make, [], 'Make');
        this.fill(this.model, [], 'Model');
        var year = parseInt(this.year.value, 10);
        if (!year) return;
        var present = {};
        this.data.forEach(function (e) { if (year >= e.start && year <= e.end) present[e.make] = true; });
        var makes = this.order.filter(function (m) { return present[m]; });
        Object.keys(present).forEach(function (m) { if (makes.indexOf(m) === -1) makes.push(m); });
        this.fill(this.make, makes.map(function (m) { return { label: m, value: m }; }), 'Make');
        this.make.disabled = makes.length === 0;
      }

      onMake() {
        this.hideResult();
        this.model.disabled = true;
        this.fill(this.model, [], 'Model');
        var year = parseInt(this.year.value, 10);
        var make = this.make.value;
        if (!year || !make) return;
        var self = this;
        this.candidates = this.data.filter(function (e) {
          return e.make === make && year >= e.start && year <= e.end;
        });
        var counts = {};
        this.candidates.forEach(function (e) { counts[e.model] = (counts[e.model] || 0) + 1; });
        var opts = this.candidates.map(function (e, i) {
          var label = counts[e.model] > 1 && e.trim ? e.model + ' · ' + e.trim : e.model;
          return { label: label, value: String(i) };
        });
        this.fill(this.model, opts, 'Model');
        this.model.disabled = opts.length === 0;
      }

      onModel() {
        var idx = parseInt(this.model.value, 10);
        if (isNaN(idx) || !this.candidates[idx]) { this.hideResult(); return; }
        this.verdict(this.candidates[idx]);
      }

      label(entry) {
        return this.year.value + ' ' + entry.make + ' ' + entry.model + (entry.trim ? ' · ' + entry.trim : '');
      }

      verdict(entry) {
        var label = this.label(entry);
        // Fit requires BOTH collection membership AND that the selected year falls
        // within this product's own coverage (not just the generation collection's).
        var year = parseInt(this.year.value, 10);
        var inRange = (!this.ymin || year >= this.ymin) && (!this.ymax || year <= this.ymax);
        var fits = !entry.prod && !!this.colSet[entry.handle] && inRange;
        if (fits) {
          this.result.className = 'product-fitment__result product-fitment__result--fit';
          this.result.innerHTML =
            CHECK +
            '<span><strong>Fits your ' + esc(label) + '.</strong>' +
            '<span class="product-fitment__sub">This part is confirmed to fit — add to cart with confidence.</span></span>';
        } else {
          var url = root() + '/' + (entry.prod ? 'products/' : 'collections/') + entry.handle;
          this.result.className = 'product-fitment__result product-fitment__result--nofit';
          this.result.innerHTML =
            XMARK +
            '<span><strong>This doesn’t fit your ' + esc(label) + '.</strong>' +
            '<a class="product-fitment__shop" href="' + esc(url) + '">Shop parts that fit your ' + esc(entry.make + ' ' + entry.model) + ' →</a></span>';
        }
        this.result.hidden = false;
      }

      hideResult() {
        if (this.result) { this.result.hidden = true; this.result.innerHTML = ''; }
      }

      restoreGarage() {
        var g;
        try { g = JSON.parse(localStorage.getItem('axiom_garage')); } catch (_) { return; }
        if (!g || !g.year || !g.make) return;
        this.year.value = String(g.year);
        this.onYear();
        if (this.make.querySelector('option[value="' + (window.CSS && CSS.escape ? CSS.escape(g.make) : g.make) + '"]')) {
          this.make.value = g.make;
          this.onMake();
          var idx = -1;
          for (var i = 0; i < this.candidates.length; i++) {
            if (this.candidates[i].model === g.model && (this.candidates[i].trim || '') === (g.trim || '')) { idx = i; break; }
          }
          if (idx >= 0) { this.model.value = String(idx); this.verdict(this.candidates[idx]); }
        }
      }
    }
  );
})();
